import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import instance from "../../../config/Config"
import axios from "axios";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
    response: null,
    selectList: null,
    responseStatus: null,
    locList: null,
    singleProperty: null,

}
export const getAllProperties = createAsyncThunk(
    "getAllProperties",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.get(`/realestate/properties/fetch-properties-list?page=${body.page}&search=${body.search}&country_code=${body.country_code}&status=${body.status}&resell_property=${body.resell_property}`);
            return response.data;
        }
        catch (error) {
            return rejectWithValue(error?.response)
        }
    }
)

// {Location SLUG LIST}
export const locationSlugList = createAsyncThunk(
    "locationSlugList",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.get(`/realestate/properties/location-slug-list`);
            return response.data;
        }
        catch (error) {
            return rejectWithValue(error?.response)
        }
    }
)
// {Add Loaction Slug}
export const AddLocationSlug = createAsyncThunk(
    "AddLocationSlug",
    async (data, { rejectWithValue }) => {
        try {
            const response = await instance.post(`/realestate/properties/create-location-slug`, data);
            return response.data;
        }
        catch (error) {
            return rejectWithValue(error?.response)
        }
    }
)
// {Insert Property}
export const insertProperties = createAsyncThunk(
    "insertProperties",
    async (data, { rejectWithValue }) => {
        try {
            const response = await instance.post(`/realestate/properties/add-properties`, data);
            return response.data;
        }
        catch (error) {
            return rejectWithValue(error?.response)
        }
    }
)
// {Insert media property}
// export const insertMediaProperties = createAsyncThunk(
//     "insertMediaProperties",
//     async (body, { rejectWithValue }) => {
//         try {
//             const formData = new FormData();
//             formData.append("property_id", body.property_id)
//             if (typeof body?.floor_plans == 'object') {
//                 for (let i = 0; i < body.floor_plans.length; i++) {
//                     // 'images' name of the formData values must match the action method param on your controller
//                     formData.append('floor_plans ', body.floor_plans[i]);
//                 }
//             }

//             const response = await axios.post('https://apimanager.viskorealestate.com/in/upload-floor-plan', formData);
//             return response.data;

//         }
//         catch (error) {
//             return rejectWithValue(error?.response)
//         }
//     }
// )
export const insertMediaProperties = createAsyncThunk(
    "insertMediaProperties",
    async (body, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append("property_id", body.property_id);

            if (body?.floor_plans && Array.isArray(body.floor_plans)) {
                if (body.floor_plans.length > 1) {
                    for (let i = 0; i < body.floor_plans.length; i++) {
                        formData.append("floor_plans[]", body.floor_plans[i]);
                    }
                } else {
                    formData.append("floor_plans", body.floor_plans[0]);
                }

            }
            const response = await axios.post(
                `https://apimanager.viskorealestate.com/${body?.countryCode}/upload-floor-plan`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data || error.message);
        }
    }
);
// {insert pdf properties}
// export const insertPdfProperties = createAsyncThunk(
//     "insertPdfProperties",
//     async (body, { rejectWithValue }) => {
//         try {
//             const formData = new FormData();
//             formData.append("property_id", body.property_id)
//             formData.append('brochure_pdf', body.brochure_pdf[0]);

//             const response = await axios.post('https://apimanager.viskorealestate.com/in/upload-brochure', formData);
//             return response.data;

//         }
//         catch (error) {
//             return rejectWithValue(error?.response)
//         }
//     }
// )

export const insertPdfProperties = createAsyncThunk(
    "insertPdfProperties",
    async (body, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append("property_id", body.property_id);

            // Safer check for brochure_pdf
            if (body?.brochure_pdf && body.brochure_pdf.length > 0) {
                formData.append("brochure_pdf", body.brochure_pdf[0]);
            }

            const response = await axios.post(
                `https://apimanager.viskorealestate.com/${body?.countryCode}/upload-brochure`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data || error.message);
        }
    }
);




// {Insert Propert document}

// export const insertPropertiesDocument = createAsyncThunk(
//     "insertPropertiesDocument",
//     async (body, { rejectWithValue }) => {
//         try {
//             const formData = new FormData();
//             formData.append("property_id", body.property_id)
//             if (typeof body?.property_images == 'object') {
//                 for (let i = 0; i < body.property_images.length; i++) {
//                     // 'images' name of the formData values must match the action method param on your controller
//                     formData.append('property_images', body.property_images[i]);
//                 }
//             }
//             // formData.append("property_images", body.property_images)
//             const response = await axios.post('https://apimanager.viskorealestate.com/in/upload-images', formData);
//             return response.data;

//         }
//         catch (error) {
//             return rejectWithValue(error?.response)
//         }
//     }
// )



export const insertPropertiesDocument = createAsyncThunk(
    "insertPropertiesDocument",
    async (body, { rejectWithValue }) => {
        try {
            const formData = new FormData();
            formData.append("property_id", body.property_id);

            // Safer check for images array
            if (body?.property_images && Array.isArray(body.property_images)) {
                if (body.property_images.length > 1) {
                    for (let i = 0; i < body.property_images.length; i++) {
                        formData.append("property_images[]", body.property_images[i]);
                    }
                } else {
                    formData.append("property_images", body.property_images[0]);
                }

            }

            const response = await axios.post(
                `https://apimanager.viskorealestate.com/${body?.countryCode}/upload-images`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );

            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response?.data || error.message);
        }
    }
);

// {All  Developer list}

export const getAllDeveloperList = createAsyncThunk(
    "getAllDeveloperList",
    async (body, { rejectWithValue }) => {
        try {
            const response = await instance.get(`/realestate/developer/fetch-all-developer`);
            return response.data;
        }
        catch (error) {
            return rejectWithValue(error?.response)
        }
    }
)

// {Delete Campaign list}
export const deletePropertyDetails = createAsyncThunk(
    "deletePropertyDetails",
    async (property_id) => {
        try {
            const response = await instance.post(
                `/realestate/properties/delete-property?property_id=${property_id}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);
// {single property}
export const fetchSingleProperties = createAsyncThunk(
    "fetchSingleProperties",
    async (property_id, { rejectWithValue }) => {
        try {
            const response = await instance.get(`/realestate/properties/fetch-single-property?property_id=${property_id}`);
            return response.data;
        }
        catch (error) {
            return rejectWithValue(error?.response)
        }
    }
)
// {Update properties}
export const updateProperties = createAsyncThunk(
    "updateProperties",
    async (data, { rejectWithValue }) => {
        try {
            const response = await instance.post(`/realestate/properties/update-property`, data);
            return response.data;
        } catch (error) {
            return rejectWithValue(error?.response);
        }
    }
);

export const PropertiesSlice = createSlice({
    name: 'PropertiesSlice',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getAllProperties.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getAllProperties.fulfilled, (state, action) => {
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload.count;
        })
        builder.addCase(getAllProperties.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });

        builder.addCase(fetchSingleProperties.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(fetchSingleProperties.fulfilled, (state, action) => {
            state.loading = false;
            state.singleProperty = action.payload;

        })
        builder.addCase(fetchSingleProperties.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });

        builder.addCase(insertProperties.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(insertProperties.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
            state.count = action.payload.count;
        })
        builder.addCase(insertProperties.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });

        builder.addCase(updateProperties.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(updateProperties.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
            state.count = action.payload.count;
        })
        builder.addCase(updateProperties.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });


        builder.addCase(insertMediaProperties.pending, (state, action) => {
            state.loading = true;
            state.responseStatus = null;
        })
        builder.addCase(insertMediaProperties.fulfilled, (state, action) => {
            state.loading = false;
            state.responseStatus = action.payload;
        })
        builder.addCase(insertMediaProperties.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });

        builder.addCase(insertPropertiesDocument.pending, (state, action) => {
            state.loading = true;
            state.responseStatus = null;
        })
        builder.addCase(insertPropertiesDocument.fulfilled, (state, action) => {
            state.loading = false;
            state.responseStatus = action.payload;
        })
        builder.addCase(insertPropertiesDocument.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });

        builder.addCase(insertPdfProperties.pending, (state, action) => {
            state.loading = true;
            state.responseStatus = null;
        })
        builder.addCase(insertPdfProperties.fulfilled, (state, action) => {
            state.loading = false;
            state.responseStatus = action.payload;
        })
        builder.addCase(insertPdfProperties.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });

        builder.addCase(AddLocationSlug.pending, (state, action) => {
            state.loading = true;
            state.responseStatus = null;
        })
        builder.addCase(AddLocationSlug.fulfilled, (state, action) => {
            state.loading = false;
            state.responseStatus = action.payload;
        })
        builder.addCase(AddLocationSlug.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });

        builder.addCase(getAllDeveloperList.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(getAllDeveloperList.fulfilled, (state, action) => {
            state.loading = false;
            state.selectList = action.payload;
        })
        builder.addCase(getAllDeveloperList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });


        builder.addCase(locationSlugList.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(locationSlugList.fulfilled, (state, action) => {
            state.loading = false;
            state.locList = action.payload;
        })
        builder.addCase(locationSlugList.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });

        builder.addCase(deletePropertyDetails.pending, (state, action) => {
            state.loading = true;
        })
        builder.addCase(deletePropertyDetails.fulfilled, (state, action) => {
            state.loading = false;
            state.response = action.payload;
        })
        builder.addCase(deletePropertyDetails.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload?.data;
        });

    },

})

export default PropertiesSlice.reducer;